import cn from 'classnames';
import * as React from 'react';
import { mergeClasses } from '@tcl-argon-utils/utils';
import styles from './icon.module.css';

// utils

function isNumber(value: unknown) {
  return typeof value === 'number';
}

// component

export type Icon = React.ComponentType<{ className?: string; height?: string | number; width?: string | number }>;

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  classes?: Partial<typeof styles>;
  enableStroke?: boolean;
}

export const Icon: React.FC<IconProps> = ({
  children,
  className = '',
  classes: classOverrides = {},
  color = 'currentcolor',
  enableStroke = false,
  height = '14px',
  width = '14px',
  ...props
}) => {
  const classes = mergeClasses(styles, classOverrides);

  return (
    <svg
      className={cn(classes.root, className)}
      {...props}
      style={
        {
          ...props.style,
          '--tcl-icon-color': color,
          '--tcl-icon-height': isNumber(height) ? `${height}px` : height,
          '--tcl-icon-width': isNumber(width) ? `${width}px` : width,
          '--tcl-icon-stroke-color': enableStroke ? color : undefined,
        } as React.CSSProperties
      }
    >
      {children}
    </svg>
  );
};
